/* eslint-disable @typescript-eslint/no-unused-vars */
import { Maybe, PaymentMethod } from '@/shared/types/generated';
import React, { createContext, useContext, useState } from 'react';

const placeholderPaymentMethod: PaymentMethod = {
  brand: 'Visa',
  last4: '4242',
  paymentMethodId: 'placeholder',
};

interface StripeContextType {
  isLoading: boolean;
  openPaymentMethodSheet: (
    customerId: string,
  ) => Promise<Maybe<PaymentMethod> | undefined>;
}

const StripeContext = createContext<StripeContextType | null>(null);

interface Props {
  children: React.ReactNode;
}

/* Placeholder provider for web */
export const StripeProvider = ({ children }: Props) => {
  const [isLoading, setIsLoading] = useState(false);

  const openPaymentMethodSheet = async (_customerId: string) => {
    return placeholderPaymentMethod;
  };

  return (
    <StripeContext.Provider value={{ isLoading, openPaymentMethodSheet }}>
      {children}
    </StripeContext.Provider>
  );
};

export const useStripe = () => {
  const context = useContext(StripeContext);
  if (!context) {
    throw new Error('useStripe must be used within a StripeProvider');
  }
  return context;
};
